import React from "react";

const defaultProps = {};

function ModalHeader({ className, children, toggle, ...rest }) {
  const classes = "modal-header bg-primary text-white";
  return (
    <div {...rest} className={classes}>
      <h5 className="modal-title">{children}</h5>
      <button
        type="button"
        className="btn btn-link close text-dark"
        onClick={toggle}
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  );
}

ModalHeader.defaultProps = defaultProps;
export default ModalHeader;
